// @flow
import styled from "styled-components";
import { Tr } from "../../components/TableX";

export const TrRow = styled(Tr)`
	&.is-ignored {
		.player-info{
			opacity: .3;
		}
		
		.player-stats{
			color: rgba(11, 27, 23, 0.29);
		}
	}
`;

export default TrRow;


// WEBPACK FOOTER //
// ./src/components/Draft/TrRow.js